import { render, staticRenderFns } from "./PopupOverlay.vue?vue&type=template&id=2cee9671&scoped=true"
import script from "./PopupOverlay.vue?vue&type=script&lang=js"
export * from "./PopupOverlay.vue?vue&type=script&lang=js"
import style0 from "./PopupOverlay.vue?vue&type=style&index=0&id=2cee9671&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cee9671",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Heading: require('/vercel/path0/components/elements/Heading.vue').default,Richtext: require('/vercel/path0/components/elements/Richtext.vue').default,Medias: require('/vercel/path0/components/elements/Medias/index.vue').default,Section: require('/vercel/path0/components/elements/Section.vue').default})
